import type { InMemoryCacheConfig } from '@apollo/client';
import type { QueryJobsCollectionExactV2Args } from '@generated/graphql';
import generatedIntrospection from '@generated/possible-types.json';

const mergeListsById = (
  // biome-ignore lint/suspicious/noExplicitAny: apollo improperly typed
  existing: any[] | undefined,
  // biome-ignore lint/suspicious/noExplicitAny: apollo improperly typed
  incoming: any[] | undefined,
  // biome-ignore lint/suspicious/noExplicitAny: apollo improperly typed
  { readField }: any
) => {
  const existingIds = (existing || []).map(job => readField('id', job));

  const newJobs = (incoming || []).filter(
    job => !existingIds.includes(readField('id', job))
  );

  return [...(existing || []), ...newJobs];
};

export const cacheOptions: InMemoryCacheConfig = {
  typePolicies: {
    Location: {
      keyFields: location =>
        location.locationString ? ['locationString'] : ['id'],
    },
    JobsCollection: {
      fields: {
        recommendations: { merge: mergeListsById },
        records: { merge: mergeListsById },
      },
    },
    UserFeatureGate: {
      merge: true,
    },
    Query: {
      fields: {
        jobsCollectionExactV2: {
          keyArgs: [
            'filters',
          ] satisfies (keyof QueryJobsCollectionExactV2Args)[],
        },
      },
    },
  },
  possibleTypes: generatedIntrospection.possibleTypes,
};
